/**
 * Mapa p-code UNE 135401 → color hex de cada grupo semafórico.
 * Portado de `semaforo-ui` (vista de lab). Lo consume `MatrizFasesBlock`.
 */
export const UNE_COLORS: Record<number, string> = {
  0: '#374151',  // AP — apagado
  1: '#22c55e',  // V — verde
  2: '#f59e0b',  // A — ámbar
  3: '#ef4444',  // R — rojo
  4: '#22c55e',  // VIR — verde int. rápido
  5: '#f59e0b',  // AI — ámbar int.
  6: '#f59e0b',  // V/A Alt. — verde/ámbar doble
  7: '#22c55e',  // VI+R — verde int. + rojo
  8: '#ef4444',  // RA — rojo + ámbar
  9: '#f59e0b',  // V+AI — verde + ámbar int. (protección)
  10: '#22c55e', // VIR+AI — verde rápido + ámbar int.
  11: '#ef4444', // R+AI — rojo + ámbar int.
  // v2 §5.2 — códigos UNE adicionales
  17: '#f59e0b', // Verde + Ámbar
  18: '#ef4444', // Rojo intermitente
  19: '#ef4444', // Rojo + intermitente doble V/A
  20: '#f59e0b', // Intermitente doble R/A
  21: '#f59e0b', // Verde + intermitente doble R/A
};

/** Color de respaldo para un p-code desconocido (apagado). */
export const UNE_COLOR_FALLBACK = '#374151';
